import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setGroups, setPaymentData, setPromotionsData, setPromotionsSalesIDArray } from '../reducers/reposReducers';
import ConvertNumber from '../components/ConvertNumber';

const SingleItem = ({
    groups,
    productsID,
    currentPrice,
    unitAmount,
    name,
    setSelectedItem,
    priceListPositionName,
    expirationDateTo,
    state,
    entryFee,
}) => {
    const dispatch = useDispatch();

    let [checked, setChecked] = React.useState(state);

    return (
        <li
            className="price-variant"
            onClick={() => {
                dispatch(setGroups(groups));
                dispatch(setPaymentData({
                    "selectedPaymentMethod": null,
                    "selectedCard": null
                }));
                dispatch(setPromotionsData(null));
                dispatch(setPromotionsSalesIDArray(null));
            
                localStorage.setItem('getGroup', JSON.stringify(groups));
                setChecked(true);
                setSelectedItem(productsID);
                localStorage.setItem('productsID', productsID);
                localStorage.setItem('amount', currentPrice);
                localStorage.setItem('priceListPositionName', priceListPositionName);
                localStorage.setItem('expirationDateTo', expirationDateTo);
            }}
        >
            <input
                readOnly
                type="radio"
                id={productsID}
                name="pricevariant"
                value="roczna"
                className="form__radio price-variant__input"
                required
                checked={checked}
            />
            <label htmlFor={productsID} className="price-variant__card">
                <div className="price-variant__title">Rodzaj płatności: {name}</div>
                <div className="price-variant__price">
                    <div>
                        <span id="price-variant-price-roczna"> {ConvertNumber(currentPrice)} </span>
                        zł
                    </div>
                </div>
                <div className="price-variant__monthly">
                    <div>
                        <span id="price-variant-monthly-roczna">
                            {groups.paymentTypesDVID === 2
                                ? ConvertNumber(currentPrice) === ConvertNumber(unitAmount)
                                    ? ' '
                                    : ConvertNumber(unitAmount)
                                : ''}
                        </span>{' '}
                        {groups.paymentTypesDVID === 2
                            ? ConvertNumber(currentPrice) === ConvertNumber(unitAmount)
                                ? ' '
                                : 'zł / miesiąc'
                            : ''}
                    </div>
                </div>
                <div className="price-variant__entryfee">
                    <div>
                        Opłata wpisowa:{' '}
                        <span id="price-variant-entryfee-roczna">{ConvertNumber(entryFee)}</span> zł
                    </div>
                </div>
                <div className="price-variant__button">wybierz</div>
                <svg
                    className="price-variant__check-icon"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M39.6591 20.2832C39.6591 30.9837 30.9846 39.6582 20.2841 39.6582C9.58354 39.6582 0.909088 30.9837 0.909088 20.2832C0.909088 9.58266 9.58354 0.908203 20.2841 0.908203C30.9846 0.908203 39.6591 9.58266 39.6591 20.2832ZM18.043 30.5421L32.418 16.1671C32.9061 15.679 32.9061 14.8875 32.418 14.3994L30.6503 12.6316C30.1621 12.1434 29.3707 12.1434 28.8825 12.6316L17.1591 24.3549L11.6857 18.8816C11.1976 18.3934 10.4061 18.3934 9.91792 18.8816L8.15018 20.6493C7.66206 21.1374 7.66206 21.9289 8.15018 22.417L16.2752 30.542C16.7634 31.0302 17.5548 31.0302 18.043 30.5421Z" />
                </svg>
            </label>
        </li>
    );
};
export default SingleItem;
